import axios from 'axios';

const getUserCorporation = () => axios.get('corporation');
const getTimeZone = () => axios.get('corporation/getTimeZones/');
const updateCorporation = ({id, values}) => axios.patch(`corporation/${id}`, values);

export default {
    getUserCorporation,
    getTimeZone,
    updateCorporation,
};
